import { ShareTypes } from '@ta-interaktiv/types/lib/www.tenant.ch/disco-api/v1/Sharing'
import { shareSignalEndpoint } from './sharingApiEndpoint'
import { handleRequest } from './handleRequest'

const defaultOptions = {
  subdomain: 'www',
  version: 'v1'
}

/**
 * Post a share signal to the backstage API
 * @param domainName - The domain name the share is made from. Without the top level domain.
 * @param articleId
 * @param shareType
 */
export function postShareSignal(
  domainName: string,
  articleId: string | number,
  shareType: ShareTypes
) {
  return fetch(shareSignalEndpoint(domainName, defaultOptions), {
    body: JSON.stringify({ articleId: articleId, sharingType: shareType }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleRequest())
    .catch((reason: Error) => {
      console.warn(
        `[postShareSignal]: share signal could not be delivered, due to
        ${reason.name}: ${reason.message}.
        While this might skew the statistics, worse things have happened.
        `
      )
    })
}
